import { Image, Text, View } from '@react-pdf/renderer';

import logo from '../../../assets/logos/appraisify/appraisify-colored.png';
import { fontStyles, headerStyles } from '../styles.ts';

export const Header = ({
  title,
  address,
  showAddress = true,
}: {
  title: string;
  address: string;
  showAddress?: boolean;
}) => (
  <View style={headerStyles.header} fixed>
    <Text style={fontStyles.h3}>{title}</Text>
    {showAddress && (
      <View style={headerStyles.logoWrapper}>
        <Text style={fontStyles.bodyLight}>{address}</Text>
        <Image src={logo} style={headerStyles.logo} />
      </View>
    )}
  </View>
);
